'use es6';

var AllowedHubs = {
  HUBS_CAMPAIGN: 'HUBS_CAMPAIGN',
  HUBS_CONTENT: 'HUBS_CONTENT',
  HUBS_CTA: 'HUBS_CTA',
  HUBS_MEDIUM: 'HUBS_MEDIUM',
  HUBS_SIGNUP_URL: 'HUBS_SIGNUP_URL',
  HUBS_SOURCE: 'HUBS_SOURCE'
};
export default AllowedHubs;